import React from 'react';
import './index.css';
import backTopImg from '../../static/imgs/backtop_icon.png';

class BackTop extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount () {
  }
  render () {
    return (
      <div className="backTop" onClick={this.backToTop.bind(this)}>
        <img src={backTopImg} />
      </div>
    );
  }
  backToTop () {
    console.log(document.body.scrollTop);
    document.body.scrollTop = 0;
  }
}
export default BackTop;